import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import RoomPropertiesList from 'components/RoomPropertiesList';
import Pagination from 'components/Pagination';
import Search from 'components/Search';

import { makeAfter, withData } from 'lib';
import { SettingsRoomPropertyListPageQuery } from '__generated__/SettingsRoomPropertyListPageQuery.graphql';

const query = graphql`
  query SettingsRoomPropertyListPageQuery(
    $first: Int!
    $after: String
    $search: String
  ) {
    ...RoomPropertiesList_data
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<SettingsRoomPropertyListPageQuery>;
};

const SettingsRoomPropertyListPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<SettingsRoomPropertyListPageQuery>(
    query,
    preloadedQuery
  );

  return (
    <Page
      breadcrumbs={[
        { link: '/settings', name: 'Nustatymai' },
        { name: 'Kambarių savybės' },
      ]}>
      <Pagination>
        <Search>
          <RoomPropertiesList data={data} />
        </Search>
      </Pagination>
    </Page>
  );
};

export default withData<SettingsRoomPropertyListPageQuery>({
  query,
  reloadOnRender: false,
  variables: ({ currentUser, searchParams }) => ({
    first: currentUser.itemsPerPage,
    after: makeAfter(
      Number(searchParams.get('page')) || 0,
      currentUser.itemsPerPage
    ),
  }),
})(SettingsRoomPropertyListPage);
